/**
 * Dmon RGS Provider Configuration
 * Same API structure as PopiPlay, targeting noble-fruits game
 *
 * Symbols are ALREADY numeric from the API (like PopiPlay) — no mapping needed.
 * Just parseInt to convert string→number where needed.
 */

export const PROVIDER_CONFIG = {
  // Provider identification
  PROVIDER_NAME: "Dmon",

  // Symbol mapping: API symbol ID → game symbol ID
  // API uses 1-indexed (1-11), game uses 0-indexed (0-10)
  SYMBOL_MAP: {
    1: 0,   // w1 (wild)
    2: 1,   // h1
    3: 2,   // m1
    4: 3,   // m2
    5: 4,   // l1
    6: 5,   // l2
    7: 6,   // l3
    8: 7,   // l4
    9: 8,   // l5
    10: 9,  // sc1
    11: 10, // sc2
  },

  // Win thresholds (multiplier of bet size) — animated win tiers
  WIN_THRESHOLDS: {
    BIG_WIN_THRESHOLD: 15, // 15x - 29.99x
    SUPER_WIN_THRESHOLD: 30, // 30x - 49.99x
    MEGA_WIN_THRESHOLD: 50, // 50x - 99.99x
    EPIC_WIN_THRESHOLD: 100, // 100x - 4999.99x
    MAX_WIN_THRESHOLD: 5000, // 5000x+ (max win cap)
  },

  // Max win multiplier (bet × this value = max possible win)
  MAX_WIN_MULTIPLIER: 5000,

  // Win type constants
  WIN_TYPES: {
    REGULAR_WIN: "regular_win",
    BIG_WIN: "big_win",
    SUPER_WIN: "super_win",
    MEGA_WIN: "mega_win",
    EPIC_WIN: "epic_win",
    MAX_WIN: "max_win",
  },

  // Which wins trigger animated celebrations (full-screen win animation)
  ANIMATED_WIN_TYPES: [
    "big_win",
    "mega_win",
    "super_win",
    "epic_win",
    "max_win",
  ],

  // Error code mappings - Dmon API codes → normalized codes (WarningPopup understands these)
  ERROR_CODES: {
    // Legacy PopiPlay-compatible codes
    301: 301, // not_enough_money
    205: 205, // free_rounds_available
    206: 206, // free_rounds_ended
    401: 401, // invalid_session
    400: 400, // invalid_bet
    500: 500, // server_error
    503: 503, // maintenance
    // New Dmon API codes → normalized codes
    1001: 301, // not_enough_money → insufficient funds
    1002: 400, // invalid_bet
    1003: 401, // invalid_session
    1004: 400, // invalid_command → treat as bad request
    1005: 500, // no_active_round → treat as server error
    1006: 500, // game_not_found → treat as server error
    1007: 500, // server_error
  },
};
